import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';

const CSRF_TOKEN_STORAGE_KEY = 'csrfToken';
const CSRF_SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS'];

@Injectable()
export class RegulatedInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const regulated = localStorage.getItem('regulated') || 'false';


    const headers: Record<string, string> = { 'Regulated': regulated };


const isApiRequest =
  request.url.includes(environment.API_BASE_URL_V3);

    // Cookie-authenticated (withCredentials) requests need the CSRF token on
    // state-changing methods.
    if (isApiRequest && !CSRF_SAFE_METHODS.includes(request.method.toUpperCase())) {
      const csrfToken = localStorage.getItem(CSRF_TOKEN_STORAGE_KEY);
      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken;
      }
    }

    const modifiedReq = request.clone({
      setHeaders: headers,
      withCredentials: isApiRequest
    });
    return next.handle(modifiedReq).pipe(
      tap((event) => {
        // Capture the session CSRF token from any backend response carrying
        // one (wallet verify, auth/csrf-token).
        if (isApiRequest && event instanceof HttpResponse) {
          const csrfToken = event.body?.data?.csrf_token;
          if (csrfToken) {
            // Guard against storage exceptions (quota, disabled storage) so a
            // successful HTTP response is never turned into an app error.
            try {
              localStorage.setItem(CSRF_TOKEN_STORAGE_KEY, csrfToken);
            } catch (_error) {
              // ignore — token stays in memory for this request lifetime
            }
          }
        }
      })
    );
  }
}
